// extracted by css-extract-rspack-plugin
export default {"employerSnippet":"employer-snippet--uBpeP8rIr20e6C5F"};